import React from "react";
import Images from "../../Assets/Images";
import "./Header.css"
function Header({ value }) {
  return (
    <div className="header-container">
      <div className="header-content">
        <img src={Images.footer} alt="Logo" className="Header_logo  " />
        <h1 className="header-title">{value.name}</h1>
      </div>
    </div>
  );
}

export default Header;
